import styled from 'styled-components';

export const getBadge = (backends, rightsApp, backendUrl_) => {
  let backendUrl = backendUrl_;
  if (!backendUrl)
    switch (rightsApp) {
      case 'web':
        backendUrl = localStorage.getItem('avaBackendUrl');
        break;
      case 'scribe':
        backendUrl = localStorage.getItem('scribeBackendUrl');
        break;
      default:
        break;
    }
  let name;
  let backgroundColor;

  switch (backendUrl) {
    case 'https://scribe-playground.ava.me':
    case 'https://playground.ava.me':
    case 'stage':
      name = 'playground';
      backgroundColor = 'steelblue';
      break;
    case 'production':
    case 'https://scribe.ava.me':
    case 'https://backend.ava.me':
    case undefined:
    case null:
      name = 'production';
      backgroundColor = 'seagreen';
      break;
    default:
      name = backendUrl;
      backgroundColor = 'saddlebrown';
      break;
  }
  if (backendUrl && backends[backendUrl] && backends[backendUrl].color) {
    backgroundColor = `#${backends[backendUrl].color}`;
    ({ name } = backends[backendUrl]);
  }
  return {
    name,
    backgroundColor,
  };
};

export const BackendBadge = styled.div`
  margin-left: 3px;
  margin-right: 3px;
  padding-left: 6px;
  -webkit-app-region: no-drag;
  border-radius: 3px;
  padding-right: 6px;
  padding-top: 1px;
  padding-bottom: 2px;
`;
